<script setup>

import {computed, reactive, ref} from "vue";
import {_mft} from "../../../i18n";

const displayCreateNew = ref(false)
const state = ref('')

const newNewsletterOptions = reactive({
    name: '',
    sendRuleType: null,
});

const sendRuleTypes = [
    {
        label: _mft('communication:sendRuleTypes.onceToAll'),
        byline: 'Send to all contacts with certain tags',
        value: 'once_to_all',
    },
    {
        label: _mft('communication:sendRuleTypes.onceAssignedInTimeRange'),
        byline: 'Send to contacts who were assigned certain tags within a specific time frame',
        value: 'once_assigned_in_time_range',
    }
];

const createNewsletter = async () => {
    if (state.value !== '' || ! newNewsletterValidates) {
        return;
    }
    state.value = 'working';
    try {
        const res = await axios.post(route('api.bo.crm.newsletters.store'), {
            name: newNewsletterOptions.name,
            send_rule_type: newNewsletterOptions.sendRuleType,
        });

        if (res.data.success) {
            state.value = 'success'
            window.location.href = route('bo.crm.newsletters.edit', res.data.newsletter.id);
        } else {
            state.value = 'error'
        }
    } catch (error) {
        state.value = 'error'
    }
}

const newNewsletterValidates = computed(() => {
    return newNewsletterOptions.name.trim() !== '' && newNewsletterOptions.sendRuleType !== null;
})

</script>
<template>
    <div class="md:sticky top-2 z-topbar">
        <frosted-bar>
            <div class="flex items-center justify-between space-x-4">
                <h1>
                    {{ _mft('communication:newsletter.domainNamePlural') }}
                </h1>

                <div class="flex items-center space-x-2">
                    <story-lane-modal :module="'newsletters-v4'"></story-lane-modal>
                    <a
                        :href="route('crm.communications.settings.show')"
                    >
                        <button-secondary>
                            {{ _mft('communication:settings') }}
                        </button-secondary>
                    </a>
                    <button-primary
                        @click="displayCreateNew = true"
                    >
                        {{ _mft('communication:newsletter.createNew') }}
                    </button-primary>
                </div>
            </div>
        </frosted-bar>
    </div>

    <div class="mt-12">
        <communication-index
            type="newsletter"
            :version="4"
        ></communication-index>

        <slideout-with-slots
            v-if="displayCreateNew"
        >
            <template #title>
                <h1>{{ _mft('communication:newsletter.createNew') }}</h1>
            </template>
            <template #body>
                <div>
                    <input-text
                        v-model:content="newNewsletterOptions.name"
                        :label="_mft('communication:automationName')"
                        maxlength="250"
                    />

                    <input-radios-v2
                        :content="newNewsletterOptions.sendRuleType"
                        :options="sendRuleTypes"
                        @update:content="newNewsletterOptions.sendRuleType = $event"
                        :label="_mft('communication:sendRuleType')"
                        name="sendrule"
                    />

                    <div class="flex justify-end mt-8">
                        <button-success
                            :disabled="! newNewsletterValidates"
                            :state="state"
                            @click="createNewsletter"
                        >
                            {{ _mft('shared:action.create')}}
                        </button-success>
                    </div>

                </div>
            </template>
        </slideout-with-slots>
    </div>
</template>
